import { getIsServerEnv } from '@/shared/modules/environment';

import { getBaseUrlDependingOnAspNetCoreEnvs } from './common';

/**
 * Returns the appropriate URL to the `Static Portal`
 */
export const getUrlToStaticPortal = () => {
  return getBaseUrlDependingOnAspNetCoreEnvs({
    Prod: process.env.NEXT_PUBLIC_STATIC_PORTAL_URL_PROD,
    Test: process.env.NEXT_PUBLIC_STATIC_PORTAL_URL_TEST,
    Dynamic: process.env.NEXT_PUBLIC_STATIC_PORTAL_URL_DYNAMIC,
  });
};

/**
 * Returns the appropriate URL to the `oAuth Service`
 */
export const getUrlToOauthServiceApi = () => {
  return getBaseUrlDependingOnAspNetCoreEnvs({
    Prod: process.env.NEXT_PUBLIC_OAUTH_URL_PROD,
    Test: process.env.NEXT_PUBLIC_OAUTH_URL_TEST,
    Dynamic: process.env.NEXT_PUBLIC_OAUTH_URL_DYNAMIC,
  });
};

/**
 * Returns the appropriate URL to the `Collector Service`
 */
export const getUrlToCollectorServiceApi = () => {
  return getBaseUrlDependingOnAspNetCoreEnvs({
    Prod: process.env.NEXT_PUBLIC_COLLECTOR_URL_PROD,
    Test: process.env.NEXT_PUBLIC_COLLECTOR_URL_TEST,
    Dynamic: process.env.NEXT_PUBLIC_COLLECTOR_URL_DYNAMIC,
  });
};

/**
 * Returns the appropriate URL to the `Account Service`
 */
export const getUrlToAccountServiceApi = () => {
  return getBaseUrlDependingOnAspNetCoreEnvs({
    Prod: process.env.NEXT_PUBLIC_ACCOUNT_URL_PROD,
    Test: process.env.NEXT_PUBLIC_ACCOUNT_URL_TEST,
    Dynamic: process.env.NEXT_PUBLIC_ACCOUNT_URL_DYNAMIC,
  });
};

/**
 * Returns the appropriate URL to the `SignalR Service`
 */
export const getUrlToSignalRServiceApi = () => {
  const localBaseURL = getIsServerEnv() === true ? process.env.NODE_HOST_URL : window.location.origin;
  const urlToProxySignalRServiceApi = new URL(process.env.NEXT_PUBLIC_PROXY_SIGNALR_PREFIX, localBaseURL);

  if (process.env.NODE_ENV === 'production') {
    return getBaseUrlDependingOnAspNetCoreEnvs({
      Prod: process.env.NEXT_PUBLIC_SIGNALR_URL_PROD,
      Test: process.env.NEXT_PUBLIC_SIGNALR_URL_TEST,
      Dynamic: process.env.NEXT_PUBLIC_SIGNALR_URL_DYNAMIC,

      // Will be used only for `build:serve` mode
      Local: urlToProxySignalRServiceApi.toString(),
    });
  }

  return urlToProxySignalRServiceApi;
};
